import { useEffect } from "preact/hooks";
import { Masthead } from "../components/Masthead";
import { Catalogue } from "../components/Catalogue";
import { Planner } from "../components/Planner";
import { CourseView } from "../components/CourseView";
import { drawerId } from "../store";

export function Home() {
  useEffect(() => {
    document.title = "Slušam · raspored predmeta UNSA";
    const k = (e: KeyboardEvent) => {
      if (e.key === "Escape") drawerId.value = null;
      const tag = (document.activeElement?.tagName || "").toLowerCase();
      if (e.key === "/" && tag !== "input" && tag !== "textarea") { e.preventDefault(); document.getElementById("q")?.focus(); }
    };
    addEventListener("keydown", k);
    return () => removeEventListener("keydown", k);
  }, []);
  const id = drawerId.value;
  return (
    <>
      <Masthead />
      <main class="layout">
        <Catalogue />
        <Planner />
      </main>
      {id && <div class="scrim" onClick={() => (drawerId.value = null)} />}
      <article class={`drawer ${id ? "open" : ""}`} aria-hidden={!id}>
        <button class="close" onClick={() => (drawerId.value = null)}>×</button>
        {id && <CourseView id={id} inDrawer />}
      </article>
    </>
  );
}
